<template>
  <f7-page>
    <div
        role="region" class="main-content h-100" tabindex="0" :class="isFirstLoginTrue ? 'filter-blur-20px' : ''">
      <h1 class="sr-only">
        {{ $t('homePage.title') }}
      </h1>
      <b-container :class="{'w-60' : getCols < 5}">
        <div class="d-flex align-items-center justify-content-center h-100vh">
            <b-row align-h="start" :cols="getCols">
              <b-col v-for="(action, index) in data" :key="action.id">
                <b-container class="homeButton" :class="getColor(index)" @click="redirect(action.link)" fluid>
                    <b-row>
                        <b-col cols="9"><i :class="action.icon" class="homeButtonIcon fa"></i></b-col>
                    </b-row>
                    <b-row class="d-flex-end h-50">
                        <b-col cols="9"><div class="w-100 fs-16px card-text">{{ $t(action.title) }}</div></b-col>
                    </b-row>
                </b-container>
              </b-col>
            </b-row>
        </div>
      </b-container>
      <footer class="pb-10px">
        <b-row>
          <b-col class="xs-12 text-center">
            <b-col class="d-flex justify-content-center align-items-center">
              <img class="logoStreammind" :src="logoStreammind" :alt="$t('common.logoStreammind')">
              <span> {{ $t('common.copyright')}}</span>
              <span>{{version}}</span>
            </b-col>
          </b-col>
        </b-row>
      </footer>
  </div>
  </f7-page>
</template>

<script>
import buttonsData from '@/pages/user/data/homepageData.json'
// import _ from 'lodash'
import { errorMessageAlert } from '@/helpers/alert'
// import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {loadPage} from '@/helpers/routing'
import MoneyRoadLogo from '../../assets/static/images/homepage/moneyroad_texte_seul.png'
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'

/* import font awesome icon component */
/* import specific icons */

export default {
  name: 'CMHomepage',
  components: {
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      data: [],
      imgLogo: Logo,
      logoStreammind: StreammindImage,
      MrBgLogo: MoneyRoadLogo,
      nbButtons: 0,
      nbMaxItem: 3,
      nbMaxColor: 4,
      color: ['#4CD8C4','#F59655','#FA7C57','#EE89A6'],
      colors: ['0'],
      version: ''
     }
  },
  computed: {
    isFirstLoginTrue () {
      if (this.$engine.user.getIsFirstLogin() === '1' || this.$engine.user.get().isFirstLogin === '1') {
        return true
      } else {
        return false
      }
    },
    getCols () {
      if (this.data.length < 5) {
        if (this.data.length < 2) {
          return '1'
        } else {
          return '2'
        }
      }
      return '3'
    },
    oneLine () {
      return this.data.length / parseInt(this.getCols) === 1
    }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (!item.disabled && this.hasRight(item.right)) {
        if (item.super_admin_menu && !this.$engine.rights.getIsSuperAdmin()) {
          return
        }
        item.class = that.getCardClass() + ' ' + item.class
        availableButtons.push(item)
      }
    })
    let dataCopy = availableButtons.filter(elem => that.hasRight(elem.right))
    let settingsFound = false
    let settingsRtpFound = false
    dataCopy.forEach((item => {
      if (item.id === 3) {
        settingsFound = true
      }

      if (item.id === 4) {
        settingsRtpFound = true
      }
    }))

    if(settingsFound === true && settingsRtpFound === true) {
      dataCopy = dataCopy.filter(elem => elem.id !== 3)
    }
    this.data = dataCopy
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }
    if (this.$engine.versionAPI) {
      this.version = 'Version ' + this.$engine.versionAPI
    } else {
      this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.versionAPI = resp.data.version
          if (that.$engine.versionAPI) {
            that.version = 'Version ' + that.$engine.versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    this.tryRedirect()
  },
  methods: {
    tryRedirect () {
      let previousPage = this.$f7.getCurrentView().history[this.$f7.getCurrentView().history.length - 1]
      if (previousPage === '/login/') {
        this.$bus.emit('refresh-cache-menu')
      }
    },
    getColor(index) {
      // Récupérer la couleur en fonction de l'index
      return 'card-color-' + (index % this.color.length) + (this.oneLine ? ' w-300' : '')
    },
    getCardClass () {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    redirect (url) {
      this.$bus.$emit('switch-selected-menu', url)
      loadPage(this, { url: url })
    }
  }
}
</script>
<style scoped>

.main-content {
  background-color: #FFFFFF;
}

@media (max-width:991px) {
  .main-content {
    height: calc(100% - 44px);
  }
}

</style>
